/**
 * 分账管理
 */
import { PageContext, UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { addEditDialog, dowanLoadFile } from './_actions'
import { DialogType } from '@/config/enums'
import dayjs from 'dayjs'

/**
 * 判断分账规则的时间状态
 * @param effectiveTime 分账开始时间
 * @param expireTime 分账结束时间
 * @returns 'NOT_STARTED' | 'IN_PROGRESS' | 'APPROACHING_END' | 'ENDED'
 */
export const getTimeStatus = (effectiveTime: any, expireTime: any) => {
  const now = Date.now()
  const startTime = effectiveTime ? new Date(effectiveTime).getTime() : 0
  const endTime = expireTime ? new Date(expireTime).getTime() : 0

  // 定义30天的毫秒数
  const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000

  if (startTime && now < startTime) {
    return 'NOT_STARTED' // 未开始
  } else if (endTime && now > endTime) {
    return 'ENDED' // 已结束
  } else if (endTime && endTime - now <= THIRTY_DAYS_IN_MS) {
    return 'APPROACHING_END' // 即将到期（30天内）
  } else {
    return 'IN_PROGRESS' // 进行中
  }
}

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/order/share/rule/list',
        method: 'POST',
        // 数据格式转换：将接口返回的 list 转换为 data，并计算衍生字段
        responseTransform: (res: any) => {
          if (res && res.list) {
            // 计算每条数据的衍生字段
            const dataList = res.list.map((item: any) => {
              // 收款方数量
              const receiverCount = item.receivers ? item.receivers.length : 0

              // 总分账比例（所有 splitRatio 的总和）
              let totalSplitRatio = 0
              if (item.receivers && item.receivers.length > 0) {
                totalSplitRatio = item.receivers.reduce((sum: number, receiver: any) => {
                  return sum + (receiver.splitRatio || 0)
                }, 0)
              }

              return {
                ...item,
                receiverCount,
                totalSplitRatio,
                splitOrderCount: item.countByFeeRuleId || 0, // 已分账单量
                splitTotalAmount: item.totalAmountByRuleId || 0 // 已分账金额
              }
            })

            return {
              data: dataList,
              total: res.total || 0
            }
          }
          return res
        }
        // perm: true
      },
      add: {
        api: '/sys/admin/order/share/rule/create',
        method: 'POST',
        dialog: addEditDialog(),
        successMessage: '新增分账规则成功！'
      },
      edit: {
        api: '/sys/admin/order/share/rule/update',
        method: 'POST',
        dialog: addEditDialog(DialogType.EDIT),
        successMessage: '编辑分账规则成功！'
      },
      downloadAct: {
        ...dowanLoadFile()
      },
      detail: {
        dialog: addEditDialog(DialogType.VIEW)
      },
      updateStatus: {
        api: '/sys/admin/order/share/rule/updateShareRuleStatus',
        method: 'POST',
        message: '确定要修改状态吗？',
        payload: {
          ruleId: '${data.row.id}',
          status: 0
        }
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        { label: '无人车SN', type: 'input', prop: 'vehicleSn' },
        {
          label: '是否直投',
          type: 'select',
          prop: 'isDirectInvestment',
          options: [
            { label: '直投', value: 1 },
            { label: '非直投', value: 0 }
          ]
        },
        {
          label: '状态',
          type: 'select',
          prop: 'status',
          options: [
            { label: '启用', value: 1 },
            { label: '停用', value: 0 }
          ]
        }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add', label: '新增分账规则' }]
    },
    table: {
      noPager: true,
      operation: {
        width: 200,
        items: [
          { action: 'detail', label: '详情' },
          {
            action: 'edit',
            label: '编辑',
            visibleOn: ({ data }: PageContext) => {
              const timeStatus = getTimeStatus(data.row.effectiveTime, data.row.expireTime)

              // 规则：
              // 1. 未开始 + 启用状态 = 显示编辑按钮（支持所有内容编辑）
              // 2. 进行中 = 显示编辑按钮
              // 3. 已停止/已结束 = 不显示编辑按钮
              const showEdit =
                ['NOT_STARTED', 'APPROACHING_END', 'IN_PROGRESS'].includes(timeStatus) && data.row.status !== 0

              return showEdit
            }
          },
          {
            action: 'updateStatus',
            label: '停止',
            visibleOn: ({ data }: PageContext) => {
              const timeStatus = getTimeStatus(data.row.effectiveTime, data.row.expireTime)

              // // 规则：
              // // 1. 未开始 + 启用状态 = 显示编辑按钮（支持所有内容编辑）
              // // 2. 进行中/已结束 = 不显示编辑按钮
              // // 3. 已停止 = 不显示编辑按钮

              const showStop =
                ['NOT_STARTED', 'APPROACHING_END', 'IN_PROGRESS'].includes(timeStatus) && data.row.status !== 0

              //
              // return showEdit
              // const showStop = data.status === 1

              return showStop
            }
          },
          {
            action: 'downloadAct',
            label: '分账明细下载',
            visibleOn: ({ data }: PageContext) => {
              const timeStatus = getTimeStatus(data.row.effectiveTime, data.row.expireTime)

              // // 规则：
              // // 1. 未开始 + 启用状态 = 显示编辑按钮（支持所有内容编辑）
              // // 2. 进行中/已结束 = 不显示编辑按钮
              // // 3. 已停止 = 不显示编辑按钮

              const showStop = ['ENDED', 'APPROACHING_END', 'IN_PROGRESS'].includes(timeStatus)

              //
              // return showEdit
              // const showStop = data.status === 1

              return showStop
            }
          }
        ]
      },
      columns: [
        { label: '无人车SN', prop: 'vehicleSn', minWidth: 160 },
        {
          label: '是否直投',
          prop: 'isDirectInvestment',
          minWidth: 100,
          formatter: (row: any) => (row.isDirectInvestment === 1 ? '直投' : '非直投')
        },
        {
          label: '投放时间',
          prop: 'effectiveTime',
          minWidth: 180,
          formatter: (row: any) => (row.effectiveTime ? dayjs(row.effectiveTime).format('YYYY-MM-DD HH:mm:ss') : '-')
        },
        // {
        //   label: '结束时间',
        //   prop: 'expireTime',
        //   minWidth: 180,
        //   formatter: (row: any) => row.expireTime ? dayjs(row.expireTime).format('YYYY-MM-DD HH:mm:ss') : '-'
        // },
        { label: '投放区域', prop: 'regionName', minWidth: 160 },
        {
          label: '配送单价（元）',
          prop: 'deliveryUnitPrice',
          minWidth: 120,
          formatter: (row: any) => (row.deliveryUnitPrice ? row.deliveryUnitPrice.toFixed(2) : '-')
        },
        {
          label: '收款方数量',
          prop: 'receiverCount',
          minWidth: 120
        },
        {
          label: '总分账比例（%）',
          prop: 'totalSplitRatio',
          minWidth: 140,
          formatter: (row: any) => (row.totalSplitRatio ? row.totalSplitRatio.toFixed(2) : '0.00')
        },
        {
          label: '已分账单量',
          prop: 'splitOrderCount',
          minWidth: 120
        },
        {
          label: '已分账金额（元）',
          prop: 'splitTotalAmount',
          minWidth: 150,
          formatter: (row: any) => (row.splitTotalAmount ? row.splitTotalAmount.toFixed(2) : '0.00')
        },
        {
          label: '分账开始时间',
          prop: 'effectiveTime',
          minWidth: 120,
          formatter: (row: any) => {
            return dayjs(row.effectiveTime).format('YYYY-MM-DD HH:mm:ss') // 时间格式化
          }
        },
        {
          label: '分账结束时间',
          prop: 'expireTime',
          minWidth: 120,
          formatter: (row: any) => {
            if (row.expireTime) {
              return dayjs(row.expireTime).format('YYYY-MM-DD HH:mm:ss') // 时间格式化
            } else {
              return '长期有效' // 时间格式化
            }
          }
        },
        {
          label: '时间状态',
          prop: 'timeStatus',
          minWidth: 100,
          formatter: (row: any) => {
            // if (row.status === 0) {
            //   return '已结束'
            // }
            const timeStatus = getTimeStatus(row.effectiveTime, row.expireTime)
            const statusMap: any = {
              NOT_STARTED: '未开始',
              IN_PROGRESS: '进行中',
              APPROACHING_END: '即将到期',
              ENDED: '已结束'
            }
            return statusMap[timeStatus] || '-'
          }
        },
        {
          label: '启用状态',
          prop: 'status',
          minWidth: 100,
          formatter: (row: any) => (row.status === 1 ? '启用' : '停用')
        },
        {
          label: '创建时间',
          prop: 'gmtCreate',
          minWidth: 180,
          formatter: (row: any) => (row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '-')
        },
        { label: '创建人', prop: 'creator', minWidth: 120 }
      ]
    }
  }
}
